var _rect, _rect2, _line, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCld2026HeaderTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 448,
    width: 256,
    height: 32,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 400,
    width: 128,
    height: 48,
    rx: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 336,
    x2: 256,
    y2: 400
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 144 144 C 48 144, 48 272, 176 304"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 368 144 C 464 144, 464 272, 336 304"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 160 96 L 352 96 L 336 256 C 336 320, 288 336, 256 336 S 176 320, 176 256 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 256 136 L 272 180 L 320 180 L 280 208 L 296 256 L 256 228 L 216 256 L 232 208 L 192 180 L 240 180 Z",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCld2026HeaderTrophy);
export default __webpack_public_path__ + "static/media/cld2026-header-trophy.173a1f5fbbcbef7d620b3190fb386d7c.svg";
export { ForwardRef as ReactComponent };